import Pagination from '@/util/pagination'
import { formatDate } from '@/util/helpers'
import { postStatusesTranslations } from '@/util/postStatuses'

export default function () {
  return {
    formatDate,
    postStatusesTranslations,
    pagination: new Pagination(),
    posts: [],
    showDeleteDialog: false,
    deletingId: null,
  }
}
